<template>
  <div :class="$style.container">
    <div :class="[$style.filter, { [$style.error]: errors && errors.name }]">
      <p>Наименование</p>
      <div :class="$style.select">
        <input
          @blur="setName"
          @keyup.enter="setName"
          v-model="filters.name"
          type="text"
          :placeholder="
            $route.fullPath === '/counterparties'
              ? 'Все'
              : 'Введите наименование'
          "
        />
        <img
          v-if="filters.name"
          @click.stop="select('name', null)"
          src="/icons/cross.svg"
          alt=""
        />
      </div>
    </div>
    <div :class="[$style.filter, { [$style.error]: errors && errors.inn }]">
      <p>ИНН</p>
      <div :class="$style.select">
        <input
          @blur="setInn"
          @keyup.enter="setInn"
          v-model="filters.inn"
          type="text"
          :placeholder="
            $route.fullPath === '/counterparties' ? 'Все' : 'Введите ИНН'
          "
        />
        <img
          v-if="filters.inn"
          @click.stop="select('inn', null)"
          src="/icons/cross.svg"
          alt=""
        />
      </div>
    </div>
    <div
      v-if="$route.fullPath === '/counterparties'"
      @mouseleave="isCitiesOpen = false"
      :class="[$style.filter, { [$style.error]: errors && errors.city }]"
    >
      <p>Город</p>
      <div @mouseover="isCitiesOpen = true" :class="$style.select">
        <span :class="{ [$style.selected]: selectedValues.city }">{{
          selectedValues.city
            ? selectedValues.city
            : forCreation
            ? "Выберите город"
            : "Все"
        }}</span>
        <img v-if="!selectedValues.city" src="/icons/arrow-bottom.svg" alt="" />
        <img
          v-else
          @click.stop="select('city', null)"
          src="/icons/cross.svg"
          alt=""
        />
      </div>
      <div v-if="isCitiesOpen" :class="$style.options">
        <div
          v-for="i in cities"
          :key="i"
          @click="select('city', { title: i, slug: i })"
        >
          {{ i }}
        </div>
      </div>
    </div>
    <div
      v-else
      :class="[$style.filter, { [$style.error]: errors && errors.city }]"
    >
      <p>Город</p>
      <div :class="$style.select">
        <input
          @blur="
            $store.commit('setCounterpartiesField', {
              field: 'city',
              value: filters.city,
            })
          "
          v-model="filters.city"
          type="text"
          placeholder="Введите город"
        />
        <img
          v-if="filters.city"
          @click.stop="select('city', null)"
          src="/icons/cross.svg"
          alt=""
        />
      </div>
    </div>
    <div
      v-if="$route.fullPath === '/counterparties'"
      @mouseleave="isRegionOpen = false"
      :class="[$style.filter, { [$style.error]: errors && errors.region }]"
    >
      <p>Регион</p>
      <div @mouseover="isRegionOpen = true" :class="$style.select">
        <span :class="{ [$style.selected]: selectedValues.region }">
          {{
            selectedValues.region
              ? selectedValues.region
              : forCreation
              ? "Выберите регион"
              : "Все"
          }}</span
        >
        <img
          v-if="!selectedValues.region"
          src="/icons/arrow-bottom.svg"
          alt=""
        />
        <img
          v-else
          @click.stop="select('region', null)"
          src="/icons/cross.svg"
          alt=""
        />
      </div>
      <div v-if="isRegionOpen" :class="$style.options">
        <div
          v-for="i in regions"
          :key="i"
          @click="select('region', { title: i, slug: i })"
        >
          {{ i }}
        </div>
      </div>
    </div>
    <div
      v-else
      :class="[$style.filter, { [$style.error]: errors && errors.region }]"
    >
      <p>Регион</p>
      <div :class="$style.select">
        <input
          v-model="filters.region"
          type="text"
          placeholder="Введите регион"
          @blur="
            $store.commit('setCounterpartiesField', {
              field: 'region',
              value: filters.region,
            })
          "
        />
        <img
          v-if="filters.region"
          @click.stop="select('region', null)"
          src="/icons/cross.svg"
          alt=""
        />
      </div>
    </div>
    <div
      @mouseleave="isClassesOpen = false"
      :class="[
        $style.filter,
        { [$style.error]: errors && errors.classification },
      ]"
    >
      <p>Класс</p>
      <div @mouseover="isClassesOpen = true" :class="$style.select">
        <span :class="{ [$style.selected]: selectedValues.classification }">{{
          selectedValues.classification
            ? selectedValues.classification
            : forCreation
            ? "Выберите класс"
            : "Все"
        }}</span>
        <img
          v-if="!selectedValues.classification"
          src="/icons/arrow-bottom.svg"
          alt=""
        />
        <img
          v-else
          @click.stop="select('classification', null)"
          src="/icons/cross.svg"
          alt=""
        />
      </div>
      <div v-if="isClassesOpen" :class="$style.options">
        <div
          v-for="i in classes"
          :key="i.slug"
          @click="select('classification', i)"
        >
          {{ i.title }}
        </div>
      </div>
    </div>
    <div
      @mouseleave="isTypesOpen = false"
      :class="[$style.filter, { [$style.error]: errors && errors.product }]"
    >
      <p>Продукт</p>
      <div @mouseover="isTypesOpen = true" :class="$style.select">
        <span :class="{ [$style.selected]: selectedValues.product }">{{
          selectedValues.product
            ? selectedValues.product
            : forCreation
            ? "Выберите тип"
            : "Все"
        }}</span>
        <img
          v-if="!selectedValues.product"
          src="/icons/arrow-bottom.svg"
          alt=""
        />
        <img
          v-else
          @click.stop="select('product', null)"
          src="/icons/cross.svg"
          alt=""
        />
      </div>
      <div v-if="isTypesOpen" :class="$style.options">
        <div v-for="i in types" :key="i.slug" @click="select('product', i)">
          {{ i.title }}
        </div>
      </div>
    </div>
    <div v-if="!forCreation" @click="reset" :class="$style.reset">Сбросить</div>
  </div>
</template>

<script>
import FILTERS from "@/assets/constants/filters.json";
export default {
  data() {
    return {
      types: FILTERS.types,
      classes: FILTERS.classes,
      isTypesOpen: false,
      isCitiesOpen: false,
      isRegionOpen: false,
      isClassesOpen: false,
      selectedValues: {
        product: "",
        city: "",
        region: "",
        classification: "",
      },
      filters: {
        product: "",
        city: "",
        region: "",
        classification: "",
        inn: "",
        name: "",
      },
      isLoad: false,
      errors: [],
      interval: "",
    };
  },
  props: {
    forCreation: {
      type: Boolean,
      default: false,
    },
  },

  async mounted() {
    this.interval = setInterval(async () => {
      this.filters.isNotLoad = true;
      await this.getData();
      this.filters.isNotLoad = false;
    }, 30000);
  },
  beforeUnmount() {
    clearInterval(this.interval);
  },
  methods: {
    select(field, value) {
      if (value) {
        this.selectedValues[field] = value.title;
        this.filters[field] = value.slug;
        this.$store.commit("setCounterpartiesField", {
          field,
          value: value.slug,
        });
      } else {
        this.selectedValues[field] = "";
        this.filters[field] = "";
        this.$store.commit("setCounterpartiesField", { field, value: "" });
      }
      if (this.$route.fullPath === "/counterparties") {
        this.getData();
      }
    },
    reset() {
      for (let key in this.selectedValues) {
        this.selectedValues[key] = "";
      }
      for (let key in this.filters) {
        this.filters[key] = "";
      }
      this.getData();
    },
    resetDate(key) {
      this.filters[key] = "";
      this.getData();
    },
    async getData() {
      this.$store.dispatch("getCounterparties", this.filters);
    },
    setName() {
      this.$route.fullPath === "/counterparties"
        ? this.getData()
        : this.$store.commit("setCounterpartiesField", {
            field: "name",
            value: this.filters.name,
          });
    },
    setInn() {
      this.$route.fullPath === "/counterparties"
        ? this.getData()
        : this.$store.commit("setCounterpartiesField", {
            field: "inn",
            value: this.filters.inn,
          });
    },
  },
  computed: {
    counterpartie() {
      return this.$store.state.counterparties.counterpartie;
    },
    cities() {
      return this.$store.state.counterparties.cities;
    },
    regions() {
      return this.$store.state.counterparties.regions;
    },
    allErrors() {
      return this.$store.state.errors.errors[0];
    },
  },
  watch: {
    counterpartie() {
      if (!this.isLoad) {
        if (this.counterpartie.slug) {
          this.selectedValues = {
            product: this.counterpartie.product
              ? this.types.find((i) => i.slug === this.counterpartie.product)
                  .title
              : "",
            classification: this.counterpartie.classification
              ? this.classes.find(
                  (i) => i.slug == this.counterpartie.classification
                ).title
              : "",
          };
          this.filters.name = this.counterpartie.name;
          this.filters.inn = this.counterpartie.inn;
          this.filters.city = this.counterpartie.city;
          this.filters.region = this.counterpartie.region;
        }
        this.isLoad = true;
      }
    },
    allErrors() {
      this.errors = this.allErrors;
    },
  },
};
</script>

<style lang="scss" module>
.container {
  padding: 1.5rem;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 1.5rem;
  > div {
    width: 100%;
    p {
      @include Body3;
      color: $t-secondary;
      margin: 0 0 0.25rem 0;
    }
  }
  .filter {
    position: relative;
    .select {
      padding: 0.75rem;
      @include Subtitle;
      color: $t-secondary;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border: 1px solid $bg-separator;
      border-radius: 0.25rem;
      cursor: pointer;
      span.selected {
        color: $t-primary;
      }
      input {
        width: 100%;
        height: 100%;
        outline: 0;
        border: none;
        background-color: inherit;
        @include Subtitle;
        &::placeholder {
          @include Subtitle;
        }
      }
    }
    .options {
      border: 1px solid $bg-separator;
      border-radius: 0.25rem;
      position: absolute;
      z-index: 2;
      background-color: $bg-secondary;
      border-bottom: none;
      width: 100%;
      cursor: pointer;
      > div {
        color: $t-secondary;
        @include Subtitle;
        padding: 0.5rem;
        border-bottom: 1px solid $bg-separator;
        display: flex;
        align-items: center;
        gap: 0.5rem;
        .dot {
          width: 0.5rem;
          height: 0.5rem;
          flex: 0 0 0.5rem;
          border-radius: 50%;
          &.orange {
            background-color: $orange;
          }
          &.grey {
            background-color: $t-secondary;
          }
          &.green {
            background-color: $main-green;
          }
          &.purple {
            background-color: $purple;
          }
          &.blue {
            background-color: $blue-primary;
          }
          &.red {
            background-color: $red-primary;
          }
        }
      }
    }
    &.error {
      > p {
        color: $red;
      }
      .select {
        border: 1px solid $red;
      }
    }
  }

  .reset {
    background-color: $main-green;
    padding: 0.75rem 0;
    @include Body2;
    border-radius: 0.25rem;
    text-align: center;
    color: $t-white;
  }
}
</style>

<style lang="scss">
.date-time-picker {
  position: absolute;
  top: 0;
  left: 0;
  height: 2.5rem;
  width: 100%;
}
.fs-16 {
  display: none;
}
.custom-button {
  display: none;
}
.datepicker-button-content {
  color: $main-green !important;
}
</style>
